"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StarknetContractConnector = exports.FEE_MULTIPLIER = void 0;
const starknet_1 = require("starknet");
exports.FEE_MULTIPLIER = 1000000000000000000;
class StarknetContractConnector {
    provider;
    contractAddress;
    abi;
    constructor(provider, contractAddress, abi) {
        this.provider = provider;
        this.contractAddress = contractAddress;
        this.abi = abi;
    }
    async waitForTransaction(txHash) {
        const successState = starknet_1.TransactionFinalityStatus.ACCEPTED_ON_L2;
        const result = await this.provider.waitForTransaction(txHash, {
            successStates: [successState],
        });
        const successfulResult = result;
        let logText = `Transaction ${txHash} finished with status: ${successfulResult.execution_status}`;
        logText += `, fee: ${parseInt(successfulResult.actual_fee.amount) / exports.FEE_MULTIPLIER} ETH`;
        console.log(logText);
        return result.status?.toString() === successState.toString();
    }
    getContract() {
        return new starknet_1.Contract(this.abi, this.contractAddress, this.provider);
    }
    async getBlockNumber() {
        return (await this.provider.getBlock(starknet_1.BlockTag.latest)).block_number;
    }
}
exports.StarknetContractConnector = StarknetContractConnector;
//# sourceMappingURL=StarknetContractConnector.js.map